import { render, staticRenderFns } from "./SafetyPreventionTotal.vue?vue&type=template&id=38ed2738&scoped=true"
import script from "./SafetyPreventionTotal.vue?vue&type=script&lang=js"
export * from "./SafetyPreventionTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ed2738",
  null
  
)

export default component.exports